import { storageDateFormat,statuses } from '@/core';
import moment from 'moment';

export default function() {
	return {
		trips: [],
		tripsLoading: false,
		searchFilter: {
			etd: {
				from:moment().startOf('day')
					.subtract(7,'d')
					.format(storageDateFormat),
				to:''
			},
			fromLocation: [],
			toLocation: [],
			tripType: [],
			status: [],
			cargoCarrier: [],
		},
		tripDetails: {
			ata: {},
			atd: {},
			cargoCarrier: {},
			clerk: {},
			driver: {},
			email: {},
			endOdometer: {},
			eta: {},
			etd: {},
			fromAddress: {},
			needAccept: {},
			numberOfPallets: {},
			orders: [],
			phoneNumber: {},
			plannedRoute: {},
			routeOptimization: {},
			sendLog: [true],
			startOdometer: {},
			status: {},
			toAddress: {},
			tripStatus: {},
			ediSendingDate: {},
			type: {
				key: {},
				value: {}
			},
			wasSent: {},
			vendor: {},
			registeredDate: {},
			editedDate: {},
		},
		//Just a list of trip ids that has been sent on edi. ediSendingDate will be set on server side.
		tripsSentOnEdi: [],
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
		statuses: Object.values(statuses.operational).map(x => ({ id: x })),
	};
}
